import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dda1bc9a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("下载")

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("a", {
    href: "javascript:void(0);",
    onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.downloadFile && _ctx.downloadFile(...args)))
  }, [
    _renderSlot(_ctx.$slots, "default", {}, () => [
      _hoisted_1
    ], true)
  ]))
}